import { call, put, takeEvery, select } from "redux-saga/effects"
import { DLogin } from "apis/DLogin"
import { callApi } from "sagas/Api"
import { PUT_THIRDPARTY_INFO, setSuccess } from "actions"
import { putThirdPartyInfo } from "apis/PutThirdPartyInfo"
import { moveToTop } from "locale"

export function* handlePutThirdPartyInfo() {
  yield takeEvery(PUT_THIRDPARTY_INFO, execPutThirdPartyInfo)
}

export const getThirdPartyInfoSelecter = (state) => state.thirdPartyInfo
export function* execPutThirdPartyInfo() {
  const ThirdPartyInfo = yield select(getThirdPartyInfoSelecter)
  const { payload, error } = yield call(
    callApi,
    putThirdPartyInfo,
    ThirdPartyInfo
  )

  if (payload && !error) {
    yield put(setSuccess(payload))
  } else {
    if (error.message === "invalid token") {
      // リフレッシュトークンが無効な場合
      yield call(DLogin, { prompt: true })
    } else if (error.message === "dauth error") {
      // サーバエラーなどでトークンリフレッシュに失敗した場合
      yield call(moveToTop)
    } else {
      // APIの処理に失敗した場合
      yield call(moveToTop)
    }
  }
}
